import tempMeeApi from '../../../apis/tempMee';

/**
 * The auth-service admin route for one user's NPS answers.
 *
 * @param {string} userId - the profile's user id (the registermodel id)
 * @returns {string}
 */
const npsReviewsRoute = (userId) => `/auth-service/admin/users/${userId}/nps-reviews`;

/**
 * GOTU-16477 — every NPS answer a user gave, migrated from the monolith and
 * new, newest first. Replaces the monolith's `nps_reviews` array, which stops
 * growing once the apps post NPS to auth-service. HTTP only: failures reject
 * and the body is returned untouched for the adapter.
 *
 * @param {string} userId - the profile's user id (the registermodel id)
 * @returns {Promise<import('../types/NpsReview.api').IGetNpsReviewsApiResponse>}
 */
export const getNpsReviews = async (userId) => {
  const response = await tempMeeApi.get(npsReviewsRoute(userId));

  return response.data;
};
